import { Button } from 'react-aria-components';



interface UploadErrorProps {
	errorMessage: string | null,
	uploadReset: () => void,
}


export const UploadError = (props: UploadErrorProps) => {
	const { errorMessage, uploadReset } = props;

	return (
		<div className='droppable-file-input-info'>
			
			<h1>Chyba při odesílání souboru</h1>

			<p>{errorMessage ? errorMessage : 'Neznámá chyba'}</p>

			<Button className="app-highlight-button btn" onPress={uploadReset}>
				Zkusit znovu
			</Button>
		
		</div>
	)
}

export default UploadError;